export interface ListenerTrigger_constructor_props {
    id?: string;
    name?: string;
    payload?: any
}

export class ListenerTrigger {

    id: string;
    name: string;
    payload: any;

    constructor(props: ListenerTrigger_constructor_props = {}) {
         this.id = props.id !== undefined ? props.id : '';
         this.name = props.name !== undefined ? props.name : '';
         this.payload = props.payload !== undefined ? props.payload : null;
    }
}
